module.exports = __webpack_public_path__ + "static/img/bg_shenhe_fail@2x.f31e62ff.png";